import { Link } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-sword-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold font-heading">{siteConfig.name}</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              {siteConfig.tagline} — 经典征途国际手游官方正版下载平台，安全可靠，双平台无忧畅玩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">下载支持</h4>
            <ul className="space-y-2.5">
              <li>
                <a href={siteConfig.androidDownloadUrl} className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                  Android 版下载
                </a>
              </li>
              <li>
                <a href={siteConfig.iosDownloadUrl} className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                  iOS 版下载
                </a>
              </li>
              <li>
                <Link to="/category/updates" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200">
                  版本更新日志
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-secondary-800 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-secondary-800 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-secondary-800 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 {siteConfig.name} 版权所有 | 版本 {siteConfig.version}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}